import { render, staticRenderFns } from "./CustomerEmailVerification.vue?vue&type=template&id=62056a24&scoped=true"
import script from "./CustomerEmailVerification.vue?vue&type=script&lang=js"
export * from "./CustomerEmailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62056a24",
  null
  
)

export default component.exports